{
  "background": {
    "background-default": "rgb(250, 250, 250)",
    "background-subtle": "rgb(245, 245, 245)"
  },
  "surface": {
    "surface-default": "rgb(255, 255, 255)",
    "surface-raised": "rgb(255, 255, 255)",
    "surface-sunken": "rgb(245, 245, 245)"
  },
  "text": {
    "text-default": "rgb(14, 17, 19)",
    "text-muted": "rgb(73, 80, 84)",
    "text-subtle": "rgb(136, 143, 146)",
    "text-inverse": "rgb(255, 255, 255)",
    "text-link": "rgb(0, 38, 100)"
  },
  "border": {
    "border-default": "rgb(220, 223, 224)",
    "border-subtle": "rgb(235, 235, 235)",
    "border-strong": "rgb(136, 143, 146)"
  },
  "action": {
    "action-default": "rgb(0, 38, 100)",
    "action-hover": "rgb(0, 16, 55)",
    "action-subtle": "rgb(240, 251, 255)"
  },
  "success": {
    "success-surface": "rgb(239, 249, 237)",
    "success-text": "rgb(0, 90, 2)",
    "success-border": "rgb(143, 199, 138)",
    "success-solid": "rgb(0, 138, 7)"
  },
  "warning": {
    "warning-surface": "rgb(255, 243, 237)",
    "warning-text": "rgb(136, 47, 3)",
    "warning-border": "rgb(238, 168, 138)",
    "warning-solid": "rgb(201, 80, 0)"
  },
  "danger": {
    "danger-surface": "rgb(255, 240, 239)",
    "danger-text": "rgb(124, 6, 31)",
    "danger-border": "rgb(234, 146, 148)",
    "danger-solid": "rgb(184, 18, 55)"
  },
  "info": {
    "info-surface": "rgb(233, 238, 247)",
    "info-text": "rgb(25, 51, 102)",
    "info-border": "rgb(128, 152, 194)",
    "info-solid": "rgb(46, 82, 153)"
  }
}
